module.exports = __webpack_public_path__ + "static/media/features-split-image-01.281b28a3.jpg";